var map = {
	"./bg-1": 13,
	"./bg-1.jpg": 13,
	"./flags/en": 17,
	"./flags/en.jpg": 17,
	"./flags/it": 18,
	"./flags/it.jpg": 18,
	"./logo": 19,
	"./logo-dark": 20,
	"./logo-dark.png": 20,
	"./logo-light": 21,
	"./logo-light.png": 21,
	"./logo-sm": 22,
	"./logo-sm.png": 22,
	"./logo.png": 19,
	"./mindmap": 23,
	"./mindmap.svg": 23,
	"./pages": 24,
	"./pages.svg": 24,
	"./procne_logo": 25,
	"./procne_logo.png": 25,
	"./procne_logo_sq": 26,
	"./procne_logo_sq.png": 26,
	"./tpl/mindmap": 27,
	"./tpl/mindmap.svg": 27,
	"./tpl/pages": 28,
	"./tpl/pages.svg": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;